import React from 'react';
import { Snackbar, Alert, Slide, Fade } from '@mui/material';
import ReactDOM from 'react-dom';

const SlideTransition = (props) => {
  return <Slide {...props} direction="down" />;
};

const FadeTransition = (props) => {
  return <Fade {...props} />;
};

const transitions = {
  fade: FadeTransition,
  slide: SlideTransition,
};
export default function SnackbarNotification({ notificationHandler, showNotification, handleHideNotification }) {
  return ReactDOM.createPortal(
    <Snackbar
      open={showNotification}
      autoHideDuration={4000}
      onClose={handleHideNotification}
      TransitionComponent={transitions[notificationHandler.transition ?? 'slide']}
      anchorOrigin={
        notificationHandler?.position ? notificationHandler.position : { vertical: 'top', horizontal: 'center' }
      }
    >
      <Alert
        onClose={handleHideNotification}
        severity={notificationHandler.severity || 'success'}
        variant="filled"
        sx={{
          width: notificationHandler.width ? notificationHandler.width : '100%',
          backgroundColor: notificationHandler?.color ? notificationHandler.color : '',
          color: notificationHandler?.textColor ? notificationHandler.textColor : '',
        }}
      >
        {notificationHandler.title}
      </Alert>
    </Snackbar>,
    document.body
  );
}
